//Para importações de libraries que serão registadas de forma global

import Vue from 'vue';

import MultiSelect from 'vue-multiselect'
import {Money} from 'v-money';
import VueTippy, {TippyComponent} from "vue-tippy";
import Notification from "./Notification";
import GroupedErrors from "./GroupedErrors";
import FileUpload from "./FileUpload";
import ProductDetails from "./ecommerce/ProductDetails";
import CartRightBar from "./ecommerce/CartRightBar";
import ModalAddress from "./address/ModalAddress";
import Modal from "./Modal";
import FormAddress from "./address/FormAddress";
import CardAddress from "./address/CardAddress";
import ButtonToggleText from "./common/ButtonToggleText";
import UserDetails from "./common/UserDetails";

Vue.use(VueTippy);

const components = {
    'multi-select': MultiSelect,
    'v-money': Money,
    'tippy': TippyComponent,
    'menu-notification': Notification,
    'grouped-errors': GroupedErrors,
    'file-upload': FileUpload,
    'product-details': ProductDetails,
    'cart-right-bar': CartRightBar,
    'modal-address': ModalAddress,
    'modal': Modal,
    'form-address': FormAddress,
    'card-address': CardAddress,
    'button-toggle-text': ButtonToggleText,
    'user-details': UserDetails,
};

Object.keys(components).forEach(selector => {
    Vue.component(selector, components[selector]);
});
